import ArtworksList from "./ArtworksList";
export default ArtworksList;
